import { BaseFirestoreRepository } from 'core/base-firestore.repository';
import { TechnicalSheet } from './technical-sheet.model';

export default class TechnicalSheetRepository extends BaseFirestoreRepository<TechnicalSheet> {
  constructor() {
    super('chefs_assistant_technical_sheets');
  }
}
